import { NgClass } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { LinkComponent } from '@joii/design-system';
import { combineLatest, map, startWith } from 'rxjs';
@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [NgClass, LinkComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  darkbackground = input<boolean>(false);
  readonly supportMailto = 'mailto:support@joiistudies.com';
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);
  hidePage = toSignal(
    combineLatest([
      this.router.events.pipe(
        map(() => this.router.url),
        startWith(this.router.url)
      ),
      this.activatedRoute.queryParamMap.pipe(startWith(this.activatedRoute.snapshot.queryParamMap)),
    ]).pipe(
      map(([url, queryParams]) => {
        const onCall = url.includes('call');
        if (onCall) {
          return true;
        }
        const onReportIssue = url.includes('report-issue');
        const hideHeader = queryParams.get('hideheader');
        return onReportIssue && (hideHeader === 'true' || hideHeader === '');
      })
    ),
    { initialValue: false }
  );
  logclick(name: string) {
    const urls: Record<string, string> = {
      'Privacy Policy': 'https://www.joiipetcare.com/policies/privacy-policy',
      'Terms of Use': 'https://www.joiipetcare.com/policies/terms-of-service',
    };
    const url = urls[name];
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }
}
